import React from "react";
import { CustomTitleSubTitleComponent, CustomTitle, CustomSubTitle } from "./TitleSubtitle.styles";
import { SubTitleSizeStyles, TitleSizeStyles } from "./TitleSubtitle.variants";
import { useTheme } from "@mui/material/styles";

export interface CustomTitleSubtitleProps {
    title?: string | React.ReactElement;
    subTitle?: string | React.ReactElement;
    size?: "sm" | "md";
    centered?: boolean;
    inversed?: boolean;
}

export const TitleSubtitle = ({
    title,
    subTitle,
    size = "md",
    centered,
    inversed,
    ...rest
}: CustomTitleSubtitleProps) => {
    const theme = useTheme();

    const titleSizeStylesFn = TitleSizeStyles(theme);
    const subTitleSizeStylesFn = SubTitleSizeStyles(theme);

    if (inversed != undefined && inversed === true) {
        return (
            <CustomTitleSubTitleComponent>
                <CustomSubTitle
                    data-cy="custom-subtitle"
                    sx={{
                        ...subTitleSizeStylesFn[size],
                        textAlign: centered ? "center" : "inherit"
                    }}>
                    {subTitle}
                </CustomSubTitle>
                <CustomTitle
                    data-cy="custom-title"
                    sx={{
                        ...titleSizeStylesFn[size],
                        textAlign: centered ? "center" : "inherit"
                    }}
                    {...rest}>
                    {title}
                </CustomTitle>
            </CustomTitleSubTitleComponent>
        );
    } else {
        return (
            <CustomTitleSubTitleComponent>
                <CustomTitle
                    data-cy="custom-title"
                    sx={{
                        ...titleSizeStylesFn[size],
                        textAlign: centered ? "center" : "inherit"
                    }}
                    {...rest}>
                    {title}
                </CustomTitle>
                <CustomSubTitle
                    data-cy="custom-subtitle"
                    sx={{
                        ...subTitleSizeStylesFn[size],
                        textAlign: centered ? "center" : "inherit"
                    }}>
                    {subTitle}
                </CustomSubTitle>
            </CustomTitleSubTitleComponent>
        );
    }    
};

export interface TitleSubtitleProps extends React.ComponentProps<typeof TitleSubtitle> {
    as?: React.ElementType;
}

TitleSubtitle.displayName = "TitleSubtitle";